/**
 * Reactive hook that resets all org-specific state when the active organization changes.
 * Covers edge cases like direct URL navigation or browser back/forward that bypass the org switcher.
 */

import { useAuth } from '@clerk/clerk-react'
import { useAppDispatch } from '@saaga/shared/store/store'
import { useEffect, useRef } from 'react'

import { dispatchOrganizationReset, wasAlreadyResetForOrg } from './organization-reset.helper'

export const useOrganizationReset = (): void => {
  const { orgId } = useAuth()
  const dispatch = useAppDispatch()
  const prevOrgIdRef = useRef(orgId)

  useEffect(() => {
    if (prevOrgIdRef.current === orgId) return
    const hadPreviousOrg = prevOrgIdRef.current !== null
    prevOrgIdRef.current = orgId
    if (!hadPreviousOrg) return
    if (orgId && wasAlreadyResetForOrg(orgId)) return

    dispatchOrganizationReset(dispatch)
  }, [orgId, dispatch])
}
